import { urlPreview } from "pages/Utils"

const AuthCard = ({ logo, children }) => (
    // <div className="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
    //     <div>{logo}</div>

    //     <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
    //         {children}
    //     </div>
    // </div>

    <div className="d-flex flex-direction-row layout-login">
        <div
         className="layout-login-left"
          style={{ backgroundImage: `url('/bg-login.png')` }}
        //   style={{ backgroundImage: `url(${urlPreview(``, 'is_bg_login')})` }}
          
          >
            <div className="layout-login-left-area-logo">
                <img src="/logo-baru.png" />
                {/* <div className="login-banner-divider"></div> */}
                {/* <div className="login-banner-title">Risk Management System</div> */}
            </div>
        </div>
        <div className="layout-login-right">
            <div className="d-flex flex-direction-row justify-content-center">{logo}</div>
            {/* <div className="title-login mt-4">Halaman Login</div>
            <center>
                <div className="login-banner-divider"></div>
            </center> */}
            {/* <div style={{ height: 10 }}></div> */}
            {children}
        </div>
    </div>
)

export default AuthCard
